/*
 * Sticky-Kaufleiste mobil (Zalando-Prinzip), 2026-10-05:
 * Solange die Kundin auf der Produktseite noch keine Farbe/Laenge aktiv gewaehlt hat,
 * zeigt der Button der fixierten Leiste "Laenge waehlen" und scrollt beim Tippen zur
 * Variantenauswahl oben. Nach der Auswahl ist es wieder der normale "In den Warenkorb"-Button.
 * Nur mobil (bis 999px), Desktop unveraendert. Produkte ohne Varianten unveraendert.
 */
(function () {
  var MQ = window.matchMedia('(max-width: 999px)');

  function init() {
    var sticky = document.querySelector('product-sticky-form');
    var btn = document.getElementById('StickyAddToCart');
    if (!sticky || !btn) return;

    var stickyVariants = sticky.querySelector('product-variants');
    if (!stickyVariants) return; // Produkt ohne Varianten: normaler Button

    var mainVariants = null;
    document.querySelectorAll('product-variants').forEach(function (el) {
      if (!el.closest('product-sticky-form') && !mainVariants) mainVariants = el;
    });
    if (!mainVariants) return;

    // Beschriftung: "Laenge waehlen", wenn eine Option Laengen (z. B. 1.40) enthaelt
    var label = 'Auswählen';
    stickyVariants.querySelectorAll('select').forEach(function (s) {
      var first = s.options && s.options[0] ? s.options[0].value : '';
      if (/^[0-9]/.test(first)) label = 'Länge wählen';
    });

    var chosen = /[?&]variant=/.test(window.location.search);

    function apply() {
      var active = MQ.matches && !chosen;
      btn.classList.toggle('ec-needs-choice', active);
      btn.setAttribute('data-choice-label', label);
      if (active && btn.disabled) btn.disabled = false;
    }

    function markChosen() {
      if (chosen) return;
      chosen = true;
      btn.classList.remove('ec-needs-choice');
    }

    mainVariants.addEventListener('change', markChosen);
    mainVariants.addEventListener('click', function (e) {
      if (e.target.closest('.combo-box__option-item, .block-swatch, .color-swatch, input')) markChosen();
    });

    btn.addEventListener('click', function (e) {
      if (!btn.classList.contains('ec-needs-choice')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var top = mainVariants.getBoundingClientRect().top + window.pageYOffset - 90;
      window.scrollTo({ top: top, behavior: 'smooth' });
      mainVariants.classList.add('ec-variants-highlight');
      setTimeout(function () { mainVariants.classList.remove('ec-variants-highlight'); }, 1600);
    }, true);

    if (MQ.addEventListener) MQ.addEventListener('change', apply);
    apply();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();